// 메뉴
import { AiFillHome } from 'react-icons/ai'
import { AiFillTrophy } from 'react-icons/ai'
import { AiFillYoutube } from 'react-icons/ai'

// sns
import { FiGithub } from 'react-icons/fi'
import { FiInstagram } from 'react-icons/fi'

export const menuText = [
    {
        title: "홈",
        icon: <AiFillHome />,
        src: "/"
    },
    {
        title: "추천 영상",
        icon: <AiFillTrophy />,
        src: "/Today"
    },
    {
        title: "유튜버",
        icon: <AiFillYoutube />,
        src: "/Youtuber"
    },
]

export const keywordText = [
    {
        title: "지무비",
        src: "/search/지무비"
    },
    {
        title: "김시선",
        src: "/search/김시선"
    },
    {
        title: "달빛뮤즈",
        src: "/search/달빛뮤즈"
    },
    {
        title: "삐맨",
        src: "/search/삐맨"
    },
    {
        title: "드림텔러",
        src: "/search/드림텔러"
    },
    {
        title: "구불",
        src: "/search/구불"
    },
    {
        title: "빨강도깨비",
        src: "/search/빨강도깨비"
    },
    {
        title: "홍시네마",
        src: "/search/홍시네마"
    },
    {
        title: "띵잘",
        src: "/search/띵잘"
    },
    {
        title: "어퍼컷",
        src: "/search/어퍼컷"
    },
    {
        title: "소개해주는남자",
        src: "/search/소개해주는남자"
    },
    {
        title: "무비트립",
        src: "/search/무비트립"
    },
    {
        title: "캡틴라미",
        src: "/search/캡틴라미"
    },
    {
        title: "필름에빠지다",
        src: "/search/필름에빠지다"
    },
    {
        title: "동네비디오방",
        src: "/search/동네비디오방"
    },
    {
        title: "엔스",
        src: "/search/엔스"
    },
    {
        title: "PLAYMOVIE",
        src: "/search/PLAYMOVIE"
    },
    {
        title: "진솔한리뷰",
        src: "/search/진솔한리뷰"
    },
    {
        title: "늘보",
        src: "/search/늘보"
    },
    {
        title: "민호타우르스",
        src: "/search/민호타우르스"
    },
]

export const snsText = [
    {
        title: "Github",
        src: "https://github.com/yunyoungsik",
        icon: <FiGithub />,
    },
    {
        title: "Instagram",
        src: "https://github.com/yunyoungsik",
        icon: <FiInstagram />,
    },
]